// extracted by mini-css-extract-plugin
module.exports = {"logo":"LogoLink_logo__2PZ1f","logo__small":"LogoLink_logo__small__w_jWl","logo__big":"LogoLink_logo__big__qyDee"};